import styled from 'styled-components';

import { maxWidth } from '@utils/helpers';

export const LayoutContent = styled.div`
    padding-bottom: 40px;
    padding-top: 170px;

    ${maxWidth('md')} {
        padding-top: 200px;
    }
`;
